import React from "react";
import { ImageIcon, Maximize2Icon } from "lucide-react";
import type { DocImage } from "../../data/caseStudies";
type TallImageProps = {
  doc: DocImage;
  onOpen: (doc: DocImage) => void;
};

/** Portrait preview of a full-length image; opens the lightbox on click. */
export function TallImage({
  doc,
  onOpen
}: TallImageProps) {
  return <button type="button" onClick={() => onOpen(doc)} className="group block w-full text-left focus:outline-none" aria-label={`Open ${doc.label.toLowerCase()} image full length`} data-id="element-128" data-mp="19tyaw46sz1z1">
      <div className="relative aspect-[3/4] overflow-hidden rounded-3xl bg-paper ring-offset-4 ring-offset-cream group-focus-visible:ring-2 group-focus-visible:ring-rust" data-id="element-129" data-mp="1jn6ob6blytmr">
        {doc.image ? <img src={doc.image} alt="" className="h-full w-full object-cover object-top transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-130" data-mp="1sjo10dzmezkm" /> : <div className="flex h-full w-full flex-col items-center justify-center gap-2 text-espresso/70" data-id="element-131" data-mp="252oxb0hn3nl">
            <ImageIcon className="h-8 w-8" strokeWidth={1.25} data-id="element-132" data-mp="73w212bv4sn8" />
            <span className="text-xs font-medium uppercase tracking-wide" data-id="element-133" data-mp="74f91nzz5wmh">{doc.label} image</span>
          </div>}
        <span className="absolute bottom-5 right-5 flex h-10 w-10 items-center justify-center rounded-full bg-cream text-espresso transition-colors duration-150 group-hover:bg-rust group-hover:text-cream" data-id="element-134" data-mp="gtyt2wzfbwix">
          <Maximize2Icon className="h-4 w-4" data-id="element-135" data-mp="punb02rxuh13" />
        </span>
      </div>
    </button>;
}